import { api } from "@/lib/api/client"
import type { BaseResponse } from "@/types/api"
import type { Me } from "@/types/domain"

export async function getMe(): Promise<Me> {
  const { data } = await api.get<BaseResponse<Me>>("/exporter/me")
  if (!data.success || !data.result) {
    throw new Error(data.message ?? "Could not load profile")
  }
  return data.result
}
